import Box from '@mui/material/Box';
import JWTDecode from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Outlet } from 'react-router-dom';
import ResponsiveAppBar from './TopMenu';
import SideNav, { SIDEBAR_WIDTH } from './SideNav';
import '../index.css';

export interface Decoded {
  name: string;
  picture: string;
}

const Dashboard = () => {
  const [picture, setPicture] = useState('');
  const [name, setName] = useState('');
  const [cookies] = useCookies(['jolly']);

  useEffect(() => {
    const token = cookies.jolly;
    if (token) {
      const decoded: Decoded = JWTDecode(token);
      setPicture(decoded.picture);
      setName(decoded.name);
    }
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <ResponsiveAppBar avatarLink={picture} avatarAltText={name} />
      <SideNav />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Dashboard;
